<template>
  <v-snackbar
    v-model="internalModel"
    :color="color"
    :location="location"
    :timeout="3000"
  >
    {{ message }}

    <template v-slot:actions>
      <v-btn variant="text" @click="internalModel = false">
        {{ closeLabel }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackbarFeedback",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "secondary",
    },
    message: {
      type: String,
    },
    closeLabel: {
      type: String,
      default: "Fechar",
    },
    location: {
      type: String,
      default: "top",
    },
  },
  emits: ["update:modelValue", "close"],
  computed: {
    internalModel: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue(val) {
      if (!val) {
        this.$emit("update:modelValue", false);
      }
    },
  },
};
</script>
